import React from "react";
import { PaginatedSort } from "common/interfaces";

import Layout from "./Layout";
import Header from "./Header";
import { PaneBody } from "./PaneBody";
import PaneContent from "./PaneContent";
import SideBar from "./SideBar";
import { ResourcePaneSideBar } from "./ResourcePaneSideBar";
import { teamResourceGridProps } from "./teamResourceGridProps";

export type SearchBarSort = PaginatedSort & {
    label?: string;
    icon?: React.ReactNode;
};

export { Layout, Header, PaneBody, PaneContent, SideBar, ResourcePaneSideBar, teamResourceGridProps };

